@use "variables" as *;

.image {
  float: right;
  margin-left: $spacing-m;
  max-width: 40%;
}
